module.exports = __webpack_public_path__ + "img/12.6c1c9712.png";